import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  provinces: [],
  districts: [],
  communes: [],
  danhSachNguonPAKN: [],
  danhSachLuatPAKN: [],
  danhSachNoiDungPAKN: [],
  danhSachLinhVucPAKN: []
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
